export const TreflePlantCarouselHeight = "60vh"